import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "@/locales/es.json";
import en from "@/locales/en.json";

const savedLanguage = typeof localStorage !== "undefined" ? localStorage.getItem("preferred-language") : null;

i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
  },
  lng: savedLanguage === "en" ? "en" : "es",
  fallbackLng: "es",
  interpolation: {
    escapeValue: false,
  },
});

// Keep document metadata synchronized with the selected language. The static
// Spanish values in index.html remain available to crawlers before JavaScript
// runs; this updates them when the user selects English.
if (typeof document !== "undefined") {
  const syncDocumentMetadata = (language: string) => {
    document.documentElement.lang = language;
    const description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (description) {
      description.content = i18n.t("seo.description", { lng: language });
    }
  };

  syncDocumentMetadata(i18n.language);
  i18n.on("languageChanged", syncDocumentMetadata);
}

export default i18n;
